import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"

import {
  toggleConfirmSocialIntegrationDialog,
  toggleGigDialog,
} from "../../actions/gigs"
import { openSnackBar } from "../../actions/snack-bar"

import { publishPost } from "../../actions/misc"

import Typography from "@material-ui/core/Typography"
import { isEmpty, head } from "lodash"
import moment from "moment"
import { convertToAbbr } from "../../lib/states"
import { handleConnect } from "../../utils/handleSocialConnect"
import { hiddenLoginModal } from "../../actions/authentication"

class ConfirmSocialIntegrationDialog extends Component {
  constructor(props) {
    super(props)
  }

  handleClose = () => {
    this.props.dispatch(toggleConfirmSocialIntegrationDialog(false))
    this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
  }

  shareGig = async () => {
    const { authentication, gig } = this.props
    if (
      authentication.authenticatedUser.id &&
      !isEmpty(authentication.authenticatedUser.networks)
    ) {
      let userData = {
        userId: authentication.authenticatedUser.id,
        userTokens: authentication.authenticatedUser.networks[0],
        postBody: `New shoot open!\r\n\r\nPosition: ${gig.name}\r\nLocation: ${JSON.parse(gig.location).city
          }, ${head(convertToAbbr(JSON.parse(gig.location).state)) &&
          head(convertToAbbr(JSON.parse(gig.location).state))
            .abbr}\r\nDate: ${moment(gig.start_date).format(
              "MMM DD, YYYY"
            )}\r\n\r\nApply Here: https://crewmama.com/gigs`,
      }

      this.props
        .dispatch(publishPost(authentication.authenticatedUser.id, userData))
        .then(response => {
          this.props.dispatch(toggleConfirmSocialIntegrationDialog(false))
          this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
          this.props.dispatch(
            openSnackBar({ message: "Post is Published on Twitter" })
          )
        })
        .catch(error => {
          this.props.dispatch(toggleConfirmSocialIntegrationDialog(false))
          this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
          this.props.dispatch(
            openSnackBar({ message: "Already Posted this Gig on Twitter" })
          )
        })
    }

    if (
      authentication.authenticatedUser.id &&
      isEmpty(authentication.authenticatedUser.networks)
    ) {
      let data = {
        creator_id: authentication.authenticatedUser.id,
        network_id: 1,
      }
      this.props.dispatch(toggleConfirmSocialIntegrationDialog(false))
      this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
      handleConnect("twitter", authentication.authenticatedUser.id, data)
    }

    if (!authentication.authenticatedUser.id) {
      this.props.dispatch(toggleConfirmSocialIntegrationDialog(false))
      this.props.dispatch(toggleGigDialog({ open: true, gig: null }))
      hiddenLoginModal()
    }
  }

  render() {
    const {
      fullScreen,
      working,
      confirmSocialIntegrationDialogOpen,
      gig,
      authentication,
    } = this.props
    return (
      <Dialog
        fullScreen={fullScreen}
        open={confirmSocialIntegrationDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        disableBackdropClick
      >
        <form
          id="edit-form"
          noValidate
          autoComplete="off"
          style={{ padding: "20px" }}
        >
          {/* first case not logged in */}
          {!authentication.authenticatedUser.id && (
            <DialogTitle disableTypography style={{ textAlign: "center" }}>
              {gig && (
                <Typography variant="h6">
                  {`You need to Login/Register to share the Gig on Twitter`}
                </Typography>
              )}
              <Typography variant="h6">{"Do you want to login ?"}</Typography>
            </DialogTitle>
          )}

          {/* second case logged in and social network not integrated*/}

          {authentication.authenticatedUser.id &&
            isEmpty(authentication.authenticatedUser.networks) && (
              <DialogTitle disableTypography style={{ textAlign: "center" }}>
                {gig && (
                  <Typography variant="h6">
                    {`You need to Link your Twitter Account to share the Gig on Twitter`}
                  </Typography>
                )}
                <Typography variant="h6">
                  {"Do you want to redirect to Twitter to Link Account ?"}
                </Typography>
              </DialogTitle>
            )}

          {/* third case logged in and social network integrated*/}

          {authentication.authenticatedUser.id &&
            !isEmpty(authentication.authenticatedUser.networks) && (
              <DialogTitle disableTypography style={{ textAlign: "center" }}>
                {gig && (
                  <Typography variant="h6">
                    {`You are posting status update about the gig`}
                  </Typography>
                )}
                <Typography variant="h6">
                  {"Do you want to continue ?"}
                </Typography>
              </DialogTitle>
            )}

          <DialogContent />
          <DialogActions>
            <Button variant="contained" onClick={this.handleClose}>
              {authentication.authenticatedUser.id ? "Cancel" : "No"}
            </Button>
            <LoadingButton
              color="primary"
              variant="contained"
              buttonclicked={this.shareGig}
              type="button"
              working={working}
            >
              {authentication.authenticatedUser.id &&
                !isEmpty(authentication.authenticatedUser.networks)
                ? "Share"
                : "Yes"}
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    confirmSocialIntegrationDialogOpen:
      state.gigs.confirmSocialIntegrationDialogOpen,
    gig: state.gigs.gigDetails,
    authentication: state.authentication,
  }
}
const connector = connect(mapStateToProps)

export default connector(ConfirmSocialIntegrationDialog)
